import { render, staticRenderFns } from "./Objectives.vue?vue&type=template&id=56dac50c&scoped=true&"
import script from "./Objectives.vue?vue&type=script&lang=ts&"
export * from "./Objectives.vue?vue&type=script&lang=ts&"
import style0 from "./Objectives.vue?vue&type=style&index=0&id=56dac50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dac50c",
  null
  
)

export default component.exports